import React from 'react'
import { StyledIcon } from '../styled'
import { ReactComponent as Icon } from '../assets/min/user.svg'

const User = ({ medium, large }) => (
	<StyledIcon medium={medium} large={large}>
		<Icon />
	</StyledIcon>
)

export default User
